document.addEventListener("DOMContentLoaded", () => {
  let lastTrailTime = 0;
  const trailDelay = 50; // Delay in milliseconds (adjust as needed)
  const maxTrails = 50; // Maximum number of trail elements

  document.addEventListener("mousemove", (e) => {
    const now = Date.now();

    // Throttling: Check if enough time has passed since the last trail
    if (now - lastTrailTime > trailDelay) {
      lastTrailTime = now;

      // Create the trail element
      const trail = document.createElement("div");
      trail.className = "cursor-trail";
      document.body.appendChild(trail);

      // Set trail position
      trail.style.left = `${e.pageX}px`;
      trail.style.top = `${e.pageY}px`;

      // Remove the trail after animation ends
      trail.addEventListener("animationend", () => {
        trail.remove();
      });

      // Limit the number of trail elements in the DOM
      const trails = document.querySelectorAll(".cursor-trail");
      if (trails.length > maxTrails) {
        trails[0].remove(); // Remove the oldest trail element
      }
    }
  });
});
